import { render, staticRenderFns } from "./TaskDashboardWidgetItem.vue?vue&type=template&id=efc46488"
import script from "./TaskDashboardWidgetItem.vue?vue&type=script&lang=js"
export * from "./TaskDashboardWidgetItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports